/**
 * 监听路由改变
 */

import mitt from '@/utils/mitt'

const key = Symbol()

// 事件总线，发布/订阅模式
const emitter = mitt<Record<symbol, string>>()

let lastChangeLocale: string

/**
 * 通知locale变化
 * @param lastLocale
 */
export function notifyLocaleChange(lastLocale: string) {
  emitter.emit(key, lastLocale)
  lastChangeLocale = lastLocale
  Array.from(window.frames).forEach((win) =>
    win.postMessage({ cmd: 'localeChange', data: lastLocale }, '*'),
  )
}

/**
 * 监听locale变化
 * @param callback 回调函数
 * @param immediate 是否立即执行
 */
export function listenerLocaleChange(callback: (locale: string) => void, immediate = true) {
  emitter.on(key, callback)
  immediate && lastChangeLocale && callback(lastChangeLocale)
}

/**
 * 移除路由监听
 */
export function removeLocaleChangeListener() {
  emitter.clear()
}
